module.exports = __webpack_public_path__ + "static/img/me5.ec2207c9.png";